module.exports = __webpack_public_path__ + "img/emoji/thonk.1a3124e2c6559d408cf5b5be2e1a0e31.png";